export const getPrintCartLineRenewalValues = (line) => ({
  printId: line.printId,
  output: line.fulfillmentKind === 'digital' ? 'pdf' : line.binding,
  format: line.format,
  type: line.productType,
  coupon_code: '',
});

export const replacePrintCartLinePreview = (cart, clientLineItemId, preview) => {
  if (!Array.isArray(cart) || !clientLineItemId || !preview?.previewToken || !Number.isInteger(preview.totalPages)) {
    return { ok: false, reason: 'invalid-renewal', cart };
  }

  const targetIndex = cart.findIndex((line) => line.clientLineItemId === clientLineItemId);
  if (targetIndex < 0) return { ok: false, reason: 'line-not-found', cart };

  const target = cart[targetIndex];
  const renewedLine = {
    ...target,
    previewToken: preview.previewToken,
    totalPages: preview.totalPages,
    ...(Number.isFinite(preview.displayPrice) ? { displayPrice: preview.displayPrice } : {}),
    ...(typeof preview.printTitle === 'string' ? { printTitle: preview.printTitle } : {}),
  };
  const renewedCart = cart.map((line, index) => (index === targetIndex ? renewedLine : line));

  return { ok: true, cart: renewedCart, line: renewedLine };
};
